<template>
  <div class="wrapper">
    <div class="section page-header header-filter" :style="headerStyle">
      <div class="container">
        <div class="md-layout" v-if="conference">
          <div
            class="md-layout-item md-size-40 md-medium-size-66 md-small-size-66 md-xsmall-size-100 mx-auto"
          >
            <validation-observer ref="formValidator" v-slot="{ handleSubmit }">
              <form @submit.prevent="handleSubmit(onLogin)">
                <md-card class="md-card-login">
                  <md-card-header class="md-card-header-primary">
                    <drop-down style="margin-bottom:10px">
                      <h5
                        slot="title"
                        class="card-title"
                        style="cursor:pointer"
                        data-toggle="dropdown"
                      >
                        {{currentDescription && currentDescription.name}}
                        <i
                          class="md-icon md-icon-font"
                        >keyboard_arrow_down</i>
                      </h5>

                      <ul class="dropdown-menu" style="overflow:hidden">
                        <li v-for="conf in conferences" :key="conf.key">
                          <a
                            href="#"
                            @click="changeConference(conf)"
                          >{{conf.description && conf.description[language.code] && conf.description[language.code].name}}</a>
                        </li>
                      </ul>
                    </drop-down>
                  </md-card-header>

                  <md-card-content style="padding-top:20px">
                    <p class="description" v-if="currentDescription && currentDescription.logo">
                      <img
                        :src="currentDescription.logoImg"
                        style="max-width:200px"
                      />
                    </p>

                    <validation-provider rules="required" v-slot="v">
                      <md-field class="md-form-group" :class="{'md-invalid md-error' : v.failed}">
                        <md-icon>account_circle</md-icon>
                        <label class="required">{{ $t('Username') }}</label>
                        <md-input v-model="model.username" />
                      </md-field>
                      <p class="md-error regular">
                        <span v-for="error in v.errors" :key="error">{{error}}</span>
                      </p>
                    </validation-provider>

                    <validation-provider rules="required" v-slot="v">
                      <md-field class="md-form-group" :class="{'md-invalid md-error' : v.failed}">
                        <md-icon>lock_outline</md-icon>
                        <label class="required">{{ $t('Password') }}</label>
                        <md-input v-model="model.password" type="password" />
                      </md-field>
                      <p class="md-error regular">
                        <span v-for="error in v.errors" :key="error">{{error}}</span>
                      </p>
                    </validation-provider>
                  </md-card-content>

                  <md-card-actions>
                    <md-button
                      class="md-button md-round md-primary md-sm md-theme-default md-blue-border"
                      type="submit"
                    >{{ $t('log in') }}</md-button>
                    <md-button
                      class="md-button md-round md-primary md-sm md-theme-default md-blue-border"
                      @click="onSkip"
                    >{{ $t('skip') }}</md-button>
                  </md-card-actions>

                  <md-card-actions>
                    <md-button
                      class="md-simple md-link md-sm"
                      @click="onForgotPassword"
                    >{{ $t('forgot password?') }}</md-button>
                  </md-card-actions>
                </md-card>
              </form>
            </validation-observer>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Mixins from "@/plugins/basicMixins";
import { mapGetters, mapActions } from "vuex";
import axios from "@/util/axios";
import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import { required } from "vee-validate/dist/rules";
import { DropDown } from "@/components";
extend("required", required);

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    DropDown
  },
  mixins: [Mixins.HeaderImage],
  bodyClass: "login-page",
  computed: {
    ...mapGetters({
      language: "language/current",
      conference: "conference/current",
      conferences: "conference/all"
    }),
    currentDescription() {
      if (!this.conference || !this.conference.description) return null;
      return this.conference.description[this.language.code] || null;
    }
  },
  data() {
    return {
      image: require("@/assets/img/background.png"),
      model: {
        username: null,
        password: null
      }
    };
  },
  methods: {
    async changeConference(conf) {
      await this.$store.dispatch("conference/changeCurrent", conf);
    },
    async onLogin() {
      let loader = this.$loading.show();

      try {
        let token = (await axios.post("auth/token", this.model)).data.token;
        if (token) {
          await this.changeConference(this.conference);
          await this.$store.dispatch("user/login", token);
          this.$router.push({ name: "main" });
        } else {
          throw this.$t("Invalid username or password");
        }
      } catch (exception) {
        let msg;
        if (exception == "Unauthorized") {
          msg = this.$t("Invalid username or password");
        } else {
          msg = exception;
        }

        this.$swal({
          icon: "error",
          title: this.$t("Error"),
          text: msg
        });
      } finally {
        loader.hide();
      }
    },
    async onSkip() {
      await this.changeConference(this.conference);
      await this.$store.dispatch("user/skip");
      this.$router.push({ name: "main" });
    },
    onForgotPassword() {
      this.$router.push({ name: "forgotpassword" });
    }
  },
  async mounted() {
    await this.$store.dispatch("conference/init", true);
  },
  watch: {
    language() {
      this.$refs.formValidator.validate();
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card .md-card-header a {
  color: #333333 !important;

  &:hover {
    color: white !important;
  }
}
.page-header {
  height: 100vh;
}
@media (max-width: 420px) {
  .page-header .container {
    margin-left: 0px;
    margin-right: 0px;
    max-width: 100% !important;
  }
  .md-layout {
    width: 380px;
  }
}
@media (max-width: 400px) {
  .page-header .container {
    margin-left: 0px;
    margin-right: 0px;
    max-width: 100% !important;
  }
  .md-layout {
    width: 360px;
  }
}
@media (max-width: 380px) {
  .page-header .container {
    margin-left: 0px;
    margin-right: 0px;
    max-width: 100% !important;
  }
  .md-layout {
    width: 350px;
  }
}

@media (max-height: 813px) {
  .page-header .page-header .container {
    position: absolute !important;
    top: 70px;
  }
  .page-header {
    height: 110vh;
  }
}
@media (max-height: 580px) {
  .page-header {
    height: 130vh;
  }
}
</style>